export const flowGroupZH = {
  flowGroup1: '编辑',
  flowGroup2: '请认真选择参与组别。',
  flowGroup3: '在',
  flowGroup4: '之前可以修改',
  flowGroup5: '次',
  flowGroup6: '提交后不允许修改。',
  flowGroup7: '参与组别',
  flowGroup8: '剩余',
  flowGroup9: '提交',
  flowGroup10: '取消',
  flowGroup11: '请确保以上所有信息填写准确',
  flowGroup12: '组别一旦确定，不得随意修改。',
  flowGroup13: '确定提交参与组别吗？',
  flowGroup14: '确定',
  flowGroup15: '此项名额已满，请重新选择！',
  flowGroup16: '修改成功',
  flowGroup17: '活动组别',
  flowGroup18: '组别一旦确定， 不得随意修改。',
  flowGroup19: '确定提交吗？',
  flowGroup20: '个名额'
}

export const flowGroupEN = {
  flowGroup1: 'Edit',
  flowGroup2: 'Please choose your group carefully.',
  flowGroup3: 'It can be modified ',
  flowGroup4: 'times before the day of',
  flowGroup5: '',
  flowGroup6: 'No modifications are allowed after submission. ',
  flowGroup7: 'Participating Groups',
  flowGroup8: '',
  flowGroup9: 'Submit',
  flowGroup10: 'Cancel',
  flowGroup11: 'Please make sure all the above information is filled in accurately',
  flowGroup12: 'Once the group is chosen, it cannot be arbitrarily modified. ',
  flowGroup13: 'Are you sure you want to submit to a participating group?',
  flowGroup14: 'Confirm',
  flowGroup15: 'This spot is full, please re-select!',
  flowGroup16: 'Edited successfully',
  flowGroup17: 'Activity Group',
  flowGroup18: 'Once the group is chosen, it cannot be arbitrarily modified.',
  flowGroup19: 'Are you sure you want to submit?',
  flowGroup20: 'places remaining'
}



// WEBPACK FOOTER //
// ./src/assets/locale/flow/group.js